import type { Loadable } from '@/loadingUtils'
import type { TStudent } from '@/store/student/types'
import type { Study } from '@pocketprep/types'

interface IStudentModuleState {
    currentOrgStudents: { [orgId: string]: Loadable<{ [studentId: string]: TStudent }> | undefined }
    currentStudentId: string | null
    currentOrgStudentUsers: { [orgId: string]: Loadable<{ [studentUserId: string]: Study.Class.UserJSON }> | undefined }
    currentOrgStudentUEM: {
        [orgId: string]: Loadable<{ [studentUserId: string]: Study.Class.UserExamMetadataJSON[] }> | undefined
    }
    currentOrgStudentQuizzes: Study.Class.QuizJSON[]
}

export const getInitialStudentState = (): IStudentModuleState => {
    return {
        currentOrgStudents: {},
        currentStudentId: null,
        currentOrgStudentUsers: {},
        currentOrgStudentUEM: {},
        currentOrgStudentQuizzes: [],
    }
}

const moduleState = getInitialStudentState()

export default moduleState
